exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-form-register[data-v-77438ea0]{display:flex;justify-content:center;margin-top:30px}.inputIsentoChecked[data-v-77438ea0]{background-color:green}@media (max-width:990px){.content-form-login[data-v-77438ea0]{display:unset}}", ""]);

// exports
